var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3125 8.4375V11.25H18.6875V8.4375C18.6875 5.84766 16.5898 3.75 14 3.75C11.4102 3.75 9.3125 5.84766 9.3125 8.4375ZM5.5625 11.25V8.4375C5.5625 3.7793 9.3418 0 14 0C18.6582 0 22.4375 3.7793 22.4375 8.4375V11.25H23.375C25.4434 11.25 27.125 12.9316 27.125 15V26.25C27.125 28.3184 25.4434 30 23.375 30H4.625C2.55664 30 0.875 28.3184 0.875 26.25V15C0.875 12.9316 2.55664 11.25 4.625 11.25H5.5625Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.5fea7b8eb01b0fc80ed6b2b4bef19f08.svg";
export { ForwardRef as ReactComponent };